var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector73(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 329,
    viewBox: "0 0 81 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-226.938 328.374C-208.023 304.986 -203.904 301.279 -184.495 286.463C-179.74 282.833 -170.496 277.121 -159.079 271.666C-155.662 270.031 -152.274 268.549 -148.933 267.19C-125.026 257.496 -98.2429 256.127 -71.792 258.38C-4.30292 264.129 56.609 227.598 74.3663 172.287C92.1711 116.871 62.9015 55.3542 17.2412 25.3323C11.3 21.4263 -16.7359 4.19626 -47.4956 1.6493C-144.615 -6.41927 -183.423 87.657 -212.806 230.8C-213.376 233.585 -215.549 246.842 -215.938 249.655L-226.938 328.383L-226.938 328.374Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector73);
export default __webpack_public_path__ + "static/media/vector7-3.6716625fbbc0b59c5f1db8cd8a54b053.svg";
export { ForwardRef as ReactComponent };